
export default class Main {

    constructor() {
        this._init();
    }


    show(){
        this.$selectwindow.classList.add('-active');
        this.$selectname.classList.add('-open');
        this.isOpen = true;
    }


    hide(){
        this.$selectwindow.classList.remove('-active');
        this.$selectname.classList.remove('-open');
        this.isOpen = false;
    }


    _init() {
        this.isOpen = false;

        this.$selectname = document.querySelector('.js-selectname');
        this.$selectwindow = document.querySelector('.js-selectwindow');
        this.items = [...document.querySelectorAll('.js-selectwindow-item')];
        this.input = document.querySelector('.js-select-value');

        this._ui();
    }


    _ui(){

        this.$selectname.addEventListener('click', e=>{
            e.stopPropagation();
            if(this.isOpen) this.hide();
            else this.show();
        });
        
        this.items.forEach($item=>{

            $item.addEventListener('click', e=>{
                e.stopPropagation();

                const key = $item.getAttribute('data-key');
                const value = $item.getAttribute('data-value');
                this._updateValue(key, value);
                this.hide();
            });
        });

        document.addEventListener('click', e=>{
            if(this.isOpen) this.hide();
        });
    }

    _updateValue(key, name){
        this.$selectname.innerHTML = name;
        this.$selectname.setAttribute('data-key', key);
        this.input.setAttribute('value', name);
    }
}   
